import { useI18n } from '@/i18n/useI18n';
import type { Locale } from '@/i18n';
import { INPUT_CLASS_NAME } from '@/components/form/FormField';

export function LanguageSwitcher() {
  const { locale, setLocale, localeNames, t } = useI18n();

  return (
    <label className="block px-3 text-sm">
      <span className="sr-only">{t('common.language')}</span>
      <select
        value={locale}
        onChange={(event) => setLocale(event.target.value as Locale)}
        className={INPUT_CLASS_NAME}
        aria-label={t('common.language')}
      >
        {Object.entries(localeNames).map(([code, name]) => (
          <option key={code} value={code}>
            {name}
          </option>
        ))}
      </select>
    </label>
  );
}
